// @flow
import { fetch } from '../../../api';
import actionTypes from '../../actionTypes';

export function uploadImageAction(id: IdType, postImageHash: string) {
  return {
    type: actionTypes.IMAGE_UPLOADED,
    data: { posts: [{ id, postImageHash }] },
    isAsynchronous: true,
  };
}

export async function getAsyncHashImage(isUploading: any, id: IdType,  dispatch: Dispatch) {
  if (!isUploading) return null;

  const { payload } = await isUploading;
  const postImageHash = payload.postImage.imageHash;

  dispatch(uploadImageAction(id, postImageHash));

  return postImageHash;
}

export default (image: string) => {
  const form = new FormData();
  form.append('user-image-upload', image);

  return fetch('post/image',
    {
      body: form,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/uploadImage.js